import styled from 'styled-components'

export const ProfileBox = styled.div `
  margin: 15px;
  padding: 15px;
  border-radius: 0px;
  margin-top: 45px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  background-color: white;
  min-height: 200px
  @media (max-width: 990px) {
      margin: 15px !important;
  }

`

export const ProfileLabels = styled.p `
  margin: 0px;
  text-align: center;
  color: ${props => props.color};
`
ProfileLabels.defaultProps = {
    color: "black"
}

export const ProfileH5 = styled.h5 `
  margin-top: 25px;
  color: black;
  text-align: center;
`

export const LabelWrapper = styled.div `
  margin: 25px;
`

export const CircleImage = styled.div `
  background: no-repeat url(${props => props.image});
  background-size:     cover;
  background-position: center center;
  margin: 0 auto;
  height: ${props => props.size}px;
  width: ${props => props.size}px;
  border-radius: ${props => props.size/2}px;
`
CircleImage.defaultProps = {
    size: 100,
    image: "https://res.cloudinary.com/theloge/image/upload/default_profile_image.jpg"
}


// WEBPACK FOOTER //
// /src/components/internal/ProfileStyle.js